import st from './styles/App.module.scss';
import Nav from './pages/Nav';
import Abouts from './pages/Abouts';
import Edus from './pages/Edus';
import Exps from './pages/Exps';
import Projects from './pages/Projects';
import Skills from './pages/Skills';
import Footer from './pages/Footer';
import { HighlightProvider } from './data/HighlightContext';

function App() {
    return (
        <HighlightProvider>
            <div className={st.App}>
                <Nav />
                <main className={st.main_container}>
                    <Abouts />
                    <Exps />
                    <Edus />
                    <Projects />
                    <Skills />
                    <Footer />
                </main>
            </div>
        </HighlightProvider>
    );
}

export default App;
